"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopConfigurationOrder = void 0;
/**
 * Defines the article type order in the shopping cart.
 */
var ShopConfigurationOrder;
(function (ShopConfigurationOrder) {
    ShopConfigurationOrder[ShopConfigurationOrder["kette"] = 1] = "kette";
    ShopConfigurationOrder[ShopConfigurationOrder["espool"] = 1] = "espool";
    ShopConfigurationOrder[ShopConfigurationOrder["ae"] = 2] = "ae";
    ShopConfigurationOrder[ShopConfigurationOrder["leitung"] = 3] = "leitung";
    ShopConfigurationOrder[ShopConfigurationOrder["ia"] = 4] = "ia";
    ShopConfigurationOrder[ShopConfigurationOrder["zugentlastung"] = 5] = "zugentlastung";
    ShopConfigurationOrder[ShopConfigurationOrder["verpackung"] = 6] = "verpackung";
    ShopConfigurationOrder[ShopConfigurationOrder["montBes"] = 7] = "montBes";
    ShopConfigurationOrder[ShopConfigurationOrder["konfektionierung"] = 8] = "konfektionierung";
    ShopConfigurationOrder[ShopConfigurationOrder["zubehoer"] = 9] = "zubehoer";
    ShopConfigurationOrder[ShopConfigurationOrder["fuehrungsrinne"] = 10] = "fuehrungsrinne";
    ShopConfigurationOrder[ShopConfigurationOrder["montageSet"] = 11] = "montageSet";
})(ShopConfigurationOrder = exports.ShopConfigurationOrder || (exports.ShopConfigurationOrder = {}));
//# sourceMappingURL=ShopConfigurationOrder.js.map